import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import styles from './sublink.css';

const Sublink = (props) => {
    const { children, onClick, modifier, type, to, href, ...other } = props;

    const classList = `${styles.sublink} ${modifier || ''}`;

    if (href) {
        return (
            <a
                className={classList}
                {...{
                    onClick,
                    type,
                    href,
                    ...other
                }}
            >
                {children}
            </a>
        );
    }

    if (to) {
        return (
            <Link
                className={classList}
                {...{
                    onClick,
                    type,
                    to,
                    ...other
                }}
            >
                {children}
            </Link>
        );
    }

    return (
        <button
            className={classList}
            {...{
                onClick,
                type,
                ...other
            }}
        >
            {children}
        </button>
    );
};

Sublink.propTypes = {
    onClick: PropTypes.func,
    modifier: PropTypes.string,
    type: PropTypes.string
};

export default Sublink;

